var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import Spinner from '@datashop/spinner';
import { styledComponents } from '@datashop/theme';
var styled = styledComponents.default, withProps = styledComponents.withProps;
var Wrapper = withProps(styled.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  position: relative;\n  user-select: none;\n\n  ", ";\n"], ["\n  cursor: pointer;\n  position: relative;\n  user-select: none;\n\n  ",
    ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return "\n      " + (disabled
        ? "\n          opacity: 0.4;\n          pointer-events: none;\n        "
        : '') + "\n    ";
});
var Button = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  box-sizing: border-box;\n  align-items: center;\n  border-radius: 4px;\n  height: 32px;\n  font-size: 14px;\n  padding: 0 12px;\n  cursor: pointer;\n\n  ", ";\n"], ["\n  position: relative;\n  display: flex;\n  box-sizing: border-box;\n  align-items: center;\n  border-radius: 4px;\n  height: 32px;\n  font-size: 14px;\n  padding: 0 12px;\n  cursor: pointer;\n\n  ",
    ";\n"])), function (props) { return "\n    border: 1px solid " + props.theme.datashop.palette.stone.light + ";\n    background: " + props.theme.datashop.palette.stone.light + "\n  "; });
var Label = withProps(styled.div)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  letter-spacing: 0.275px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  display: ", ";\n"], ["\n  letter-spacing: 0.275px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  display: ", ";\n"])), function (_a) {
    var visible = _a.visible;
    return (visible ? 'none' : 'inline-block');
});
var Input = withProps(styled.input)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: none;\n  font-size: 14px;\n  width: 100%;\n  top: 5px;\n  left: 11px;\n  height: auto;\n  display: ", ";\n  background-color: ", ";\n\n  &:focus {\n    outline: 0;\n  }\n"], ["\n  border: none;\n  font-size: 14px;\n  width: 100%;\n  top: 5px;\n  left: 11px;\n  height: auto;\n  display: ", ";\n  background-color: ", ";\n\n  &:focus {\n    outline: 0;\n  }\n"])), function (_a) {
    var visible = _a.visible;
    return (visible ? 'inline-block' : 'none');
}, function (props) { return props.theme.datashop.palette.stone.light; });
var Icon = styled.i(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-left: auto;\n  font-size: 16px;\n"], ["\n  margin-left: auto;\n  font-size: 16px;\n"])));
var StyledSpinner = styled(Spinner)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"])));
var Menu = withProps(styled.div)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 1;\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0.08), 0 3px 12px rgba(0, 0, 0, 0.12);\n  margin-top: 4px;\n  border-radius: 4px;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  transition: opacity 0.1s ease;\n\n  background-color: ", ";\n  display: ", ";\n"], ["\n  position: absolute;\n  z-index: 1;\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0.08), 0 3px 12px rgba(0, 0, 0, 0.12);\n  margin-top: 4px;\n  border-radius: 4px;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  transition: opacity 0.1s ease;\n\n  background-color: ", ";\n  display: ", ";\n"])), function (props) { return props.theme.datashop.palette.white.main; }, function (_a) {
    var visible = _a.visible;
    return (visible ? 'block' : 'none');
});
var List = styled.ul(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n"], ["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n"])));
var ListItem = withProps(styled.li)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  padding: 8px 12px;\n  line-height: 1.6;\n\n  ", "\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  padding: 8px 12px;\n  line-height: 1.6;\n\n  ",
    "\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) { return "\n      opacity: " + (props.disabled ? 0.4 : 1) + ";\n      pointer-events: " + (props.disabled ? 'none' : 'auto') + ";\n      cursor: " + (props.disabled ? 'not-allowed' : 'cursor') + ";\n      color: " + (props.light ? props.theme.datashop.palette.neutral.lightest : 'inherit') + "\n    "; }, function (props) { return props.theme.datashop.palette.stone.lightest; });
var Select = (function (_super) {
    __extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
            searchText: '',
        };
        _this.handleMenuToggle = function () {
            var search = _this.props.search;
            _this.setState({ open: !_this.state.open }, function () {
                if (search) {
                    _this.input.focus();
                }
                if (_this.state.open) {
                    _this.attachHandlersOnOpen();
                }
                else {
                    _this.removeHandlersOnClose();
                }
            });
        };
        _this.doesNodeContainClick = function (event) {
            if (!_this.wrapper.contains(event.target)) {
                _this.handleMenuToggle();
            }
        };
        _this.attachHandlersOnOpen = function () {
            document.addEventListener('mousedown', _this.doesNodeContainClick);
        };
        _this.removeHandlersOnClose = function () {
            document.removeEventListener('mousedown', _this.doesNodeContainClick);
        };
        _this.handleButtonClick = function () {
            var loading = _this.props.loading;
            if (!loading) {
                _this.handleMenuToggle();
            }
        };
        _this.handleInputClick = function (event) {
            event.stopPropagation();
        };
        _this.handleSearchChange = function (event) {
            _this.setState({
                searchText: event.target.value,
            });
        };
        _this.handleMenuItemClick = function (option) {
            _this.props.onChange(option);
            _this.handleMenuToggle();
        };
        _this.checkOptionExists = function (defaultSelection) {
            if (defaultSelection) {
                return !!_this.props.options.filter(function (option) { return option.value === defaultSelection.value; }).length;
            }
            return false;
        };
        return _this;
    }
    Select.prototype.render = function () {
        var _this = this;
        var _a = this.props, placeholder = _a.placeholder, options = _a.options, __ = _a.onChange, disabled = _a.disabled, emptySearchMsgRenderer = _a.emptySearchMsgRenderer, search = _a.search, selectedOption = _a.selectedOption, labelRenderer = _a.labelRenderer, loading = _a.loading, rest = __rest(_a, ["placeholder", "options", "onChange", "disabled", "emptySearchMsgRenderer", "search", "selectedOption", "labelRenderer", "loading"]);
        var list = options.filter(function (option) {
            return option.label.toLowerCase().includes(_this.state.searchText.toLowerCase());
        });
        var generateListItems = function () {
            if (!list.length) {
                return React.createElement(ListItem, { light: true }, emptySearchMsgRenderer);
            }
            return list.map(function (option, index) {
                return (React.createElement(ListItem, { key: index, onClick: function () { return _this.handleMenuItemClick(option); }, disabled: option.disabled }, labelRenderer(option)));
            });
        };
        var getListItem = generateListItems();
        return (React.createElement(Wrapper, __assign({ disabled: disabled || loading, innerRef: function (element) { return (_this.wrapper = element); } }, rest),
            React.createElement(Button, { onClick: this.handleButtonClick },
                React.createElement(Label, { visible: this.state.open && search }, selectedOption && this.checkOptionExists(selectedOption)
                    ? labelRenderer(selectedOption, true)
                    : placeholder),
                React.createElement(Input, { visible: this.state.open && search, onClick: this.handleInputClick, placeholder: placeholder, innerRef: function (element) {
                        _this.input = element;
                    }, onChange: this.handleSearchChange }),
                loading ? (React.createElement(StyledSpinner, null)) : (React.createElement(Icon, { className: "material-icons" }, "keyboard_arrow_down"))),
            React.createElement(Menu, { visible: this.state.open },
                React.createElement(List, null, getListItem))));
    };
    Select.defaultProps = {
        placeholder: 'Select something',
        disabled: false,
        search: false,
        selectedOption: undefined,
        labelRenderer: function (option) { return React.createElement(React.Fragment, null, option.label); },
        emptySearchMsgRenderer: React.createElement(React.Fragment, null, "No results found."),
    };
    return Select;
}(React.Component));
export default Select;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=Select.js.map